import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import AdminPostSearchModule from "./AdminPostSearchModule";
import AdminSinglePost from "./AdminSinglePost";
import Spinner from "../components/Spinner";
import classes from "./adminStatistika.module.css";

const AdminStatistika = () => {
  const [isArray, setIsArray] = useState(false);
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  const getAllStatistikaPosts = async () => {
    const { data } = await axiosPrivate.get("/getAllStatistikaPosts");
    const isArray = await Array.isArray(data.result);
    if (isArray) {
      setIsArray(true);
    }
    return data;
  };
  const allStatistikaPostsQuery = useQuery({
    queryKey: ["statistika"],
    queryFn: getAllStatistikaPosts,
    staleTime: 0,
    refetchInterval: 1000 * 60 * 60 * 12,
  });

  if (allStatistikaPostsQuery.isError) return <h2>Error...</h2>;

  const handleNewPost = () => {
    navigate("/betko-admin/kreiraj-novi-post", {
      state: "statistika",
    });
  };

  return (
    <div className={classes.container}>
      {allStatistikaPostsQuery.isLoading ? (
        <Spinner />
      ) : (
        <>
          <h1>STATISTIKA</h1>
          <div className={classes.top}>
            {isArray && allStatistikaPostsQuery.data.result !== undefined && (
              <AdminPostSearchModule type="statistika" />
            )}
            <button onClick={() => handleNewPost()} className={classes.btn}>
              Dodaj Novi
            </button>
          </div>
          <div className={classes.postContainer}>
            <div>
              {isArray && allStatistikaPostsQuery.data.result !== undefined
                ? allStatistikaPostsQuery.data.result.map((post) => {
                    return (
                      <AdminSinglePost
                        post={post}
                        key={post._id}
                        type="statistika"
                      />
                    );
                  })
                : allStatistikaPostsQuery.data.msg}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminStatistika;
